(function ($) {
  Drupal.behaviors.trendExploreMoreV1 = {
    isMobile: false,
    direction: $('html').attr('dir') || 'ltr',
    attach: function (context) {
      var self = this;
      var $modules = $('.js-trend-exploremore', context);

      $modules.each(function () {
        var $module = $(this);

        self.getDom($module);
        self.getConfig($module);
        self.getTrendTiles($module);
      });

      Unison.on('change', function () {
        self.isMobile = self.checkIfMobile();
      });
    },
    checkIfMobile: function () {
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPlargeUp = parseInt(Unison.fetch.all()['usn-medium'], 10);

      return currentBpWidth <= bPlargeUp;
    },
    getDom: function ($module) {
      $module.nodes = {};
      $module.nodes.tiles = $('.js-trend-exploremore-tiles', $module);
    },
    getConfig: function ($module) {
      $module.config = {};
      $module.config.category = $module.data('catChoice') ? $module.data('catChoice') : 'all';
      $module.config.limit = $module.data('tileCount') ? parseInt($module.data('tileCount'), 10) : 3;
      $module.config.isSlider = $module.data('isSlider');
      $module.config.isSliderMobile = $module.data('isSliderMobile');
      $module.config.breakpoints = $module.data('breakpoints');
      $module.config.sliderConfig = $module.data('sliderConfig');
    },
    setPeekingClasses: function ($module) {
      var selectedPeeking = $module.config.sliderConfig.peeking;
      var i;

      for (i in selectedPeeking) {
        $module.addClass('peeking-' + i + '-' + String(selectedPeeking[i]).replace('.', ''));
      }
    },
    initSlick: function ($module) {
      var self = this;
      var itemsPerSlide = $module.config.breakpoints['extra_large'];
      var sliderSettings = {
        infinite: true,
        slidesToShow: parseInt(itemsPerSlide, 10),
        slidesToScroll: 1,
        arrows: ($module.config.sliderConfig.arrows === 1) ? true : false,
        dots: ($module.config.sliderConfig.dots === 1) ? true : false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: parseInt($module.config.breakpoints['mobile'], 10)
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: parseInt($module.config.breakpoints['desktop'], 10)
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: parseInt($module.config.breakpoints['large'], 10)
            }
          }
        ],
        onInit: function () {
          self.setPeekingClasses($module);
        }
      };

      setTimeout(function () {
        $module.nodes.tiles.slick(sliderSettings);
      }, 100);
    },
    processData: function ($module, data) {
      var self = this;
      var $div;
      var i;

      if (data.length > 0) {
        for (i = 0; i < data.length; i++) {
          if (data[i]['rendered']) {
            if ((self.isMobile && $module.config.isSliderMobile) ||
            (!self.isMobile && $module.config.isSlider)) {
            // Slick carousel doesn't appear to work with <article>
              $div = $('<div>' + data[i]['rendered'] + '</div>');
              $module.nodes.tiles.append($div);
            } else {
              $module.nodes.tiles.append($(data[i]['rendered']));
            }
          }
        }
        setTimeout(function () {
          $module.nodes.tiles.addClass('active');
          if (self.isMobile && $module.config.isSliderMobile) {
            self.initSlick($module);
          }
          if (!self.isMobile && $module.config.isSlider) {
            self.initSlick($module);
          }
        }, 100);
      }
    },
    sortArrayOfObjects: function (arr, order = 'ascending') {
      const sortedArr = arr.sort((a, b) => {
        if (a['publish_date_epoch'] < b['publish_date_epoch']) {
          return -1;
        }
        if (a['publish_date_epoch'] > b['publish_date_epoch']) {
          return 1;
        }

        return 0;
      });

      if (order === 'descending') {
        return sortedArr.reverse();
      }

      return sortedArr;
    },
    getTrendTiles: function ($module) {
      var self = this;
      var apiUrl;
      var i;

      apiUrl = '/elc_api/blog/' + $module.config.category + '/all/' + $module.config.limit + '/0';
      $.getJSON(apiUrl, function (jsonData) {
        var jsonDataArray = [];
        var sortedPosts = [];

        for (i in jsonData) {
          jsonDataArray.push(jsonData[i]);
        }
        sortedPosts = self.sortArrayOfObjects(jsonDataArray, 'descending');
        self.processData($module, sortedPosts);
      });
    }
  };
})(jQuery);
